export const REDIRECT_TIME = {
  SECTION_NOT_FOUND: 2000,
};
